import { PagedResponse } from '@elotech/components';
import { AxiosPromise } from 'axios';
import { UNCPessoa } from 'common/type';
import { FC } from 'react';

import {
  PessoaSearchMultiple,
  PessoaSearchPropsMultiple
} from './PessoaSearchMultiple';
import {
  PessoaSearchPropsSingle,
  PessoaSearchSingle
} from './PessoaSearchSingle';

export type PessoaSearchPropsBase = {
  name: string;
  error?: any;
  noLabel?: boolean;
  label?: string;
  disabled?: boolean;
  onSearch: (search: string) => AxiosPromise<PagedResponse<UNCPessoa>>;
  onCreateValue?: (texto: string) => AxiosPromise<UNCPessoa>;
};

export type PessoaSearchProps = (
  | PessoaSearchPropsSingle
  | PessoaSearchPropsMultiple
) & { multiple?: boolean };

const PessoaSearch: FC<PessoaSearchProps> = ({ multiple, ...props }) => {
  return multiple ? (
    <PessoaSearchMultiple {...(props as PessoaSearchPropsMultiple)} />
  ) : (
    <PessoaSearchSingle {...(props as PessoaSearchPropsSingle)} />
  );
};

export { PessoaSearch };
